import React from 'react';
import {DashboardView} from '../dashboard/types';
import {RefreshCw} from 'lucide-react';

interface HeaderProps {
  activeView: DashboardView;
  greetingName: string;
  now: Date;
  isLoading: boolean;
  onToggleCalendar: () => void;
  onRefresh: () => void;
}

const Header: React.FC<HeaderProps> = ({
  activeView,
  greetingName,
  now,
  isLoading,
  onToggleCalendar,
  onRefresh,
}) => {
  return (
    <header className='board-header'>
      <div>
        <h1>Hello {greetingName || 'there'} !</h1>
        <p className='header-subtitle'>
          {activeView === 'profile'
            ? 'Manage your account details.'
            : activeView === 'events'
              ? 'Manage event dates, prices and availability.'
            : activeView === 'messages'
              ? 'Review customer contact messages.'
            : activeView === 'menu'
                ? 'Create the food and drink menu shown on your website.'
              : activeView === 'reports'
                ? 'Review customer reservation activity and recurring visits.'
              : 'Here is your daily statistic'}
        </p>
      </div>
      <div className='header-meta'>
        <div className='header-meta-row'>
          <div className='calendar-wrap'>
            <button
              type='button'
              className='date-chip date-trigger'
              onClick={onToggleCalendar}>
              {now.toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
              })}
            </button>
          </div>
          <button
            onClick={onRefresh}
            disabled={isLoading}>
            {isLoading ? 'Loading...' : <RefreshCw />}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
